// generated from 23_898 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const segmentCohortFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("segment_cohort_filter"),
  comparison_key: z.enum([
    "7", // 16_367 (68.49%)
    "8", // 7_531 (31.51%)
  ]),
  display_name: z.string(),
  // undefined: 4_437 (18.57%), defined 19_461 (81.43%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
